import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-label rounded-full bg-accent-100 text-accent-800 border border-accent-200">
              <i className="ri-question-line" />
              常见问题
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              关于地址与访问的高频疑问
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              以下问题覆盖了查找入口、理解地址变化以及安全访问时最常遇到的情况，点击即可展开查看说明。
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((item, idx) => {
                const isOpen = openIndex === idx;
                return (
                  <div
                    key={item.q}
                    className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : idx)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center gap-4 text-left px-5 py-4 cursor-pointer"
                    >
                      <span className="font-heading text-sm font-semibold text-primary-700">
                        {String(idx + 1).padStart(2, "0")}
                      </span>
                      <span className="flex-1 font-heading text-base font-semibold text-foreground-950">
                        {item.q}
                      </span>
                      <span className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 pl-[3.4rem]">
                        <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}